import { useEffect, useState } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useSearchParams } from 'react-router-dom';
import StepWizard from 'react-step-wizard';
import { AnalyticsEvent, captureAnalyticsEvent } from '../../constant/Events';
import { useAuth } from '../../hooks';
import { useNavigateWithSearchParam } from '../../hooks/useNavigateWithSearchParam';
import { getWhiteLabellingCompanyName } from '../../stores/selectors/env.selector';
import { getCurrentTheme } from '../../stores/selectors/theme.selector';
import { getbrandname } from '../../utils/SearchParam.Utils';
import { RegisterCreateAccount } from './RegisterCreateAccount.component';

export const Register = () => {
  const theme = useSelector(getCurrentTheme);
  const auth = useAuth();
  const { t } = useTranslation();
  const { navigate } = useNavigateWithSearchParam();
  const whiteLabelCompanyName: any = useSelector(getWhiteLabellingCompanyName);
  const [isRegisterSuccess, setIsRegisterSuccess] = useState(false);
  const [searchParams] = useSearchParams();
  const [pauseLoadingForSsoCheck, setPauseLoadingForSsoCheck] = useState(true);

  useEffect(() => {
    if (auth.user) {
      navigate('/', { replace: true });

      return;
    }

    const registerEmailSearchParam = searchParams.get('email');
    if (auth.domainHasSsoConfiguration(registerEmailSearchParam)) {
      auth.signInFederated(registerEmailSearchParam);
    } else {
      setPauseLoadingForSsoCheck(false);
    }
  }, [auth, searchParams, setPauseLoadingForSsoCheck, navigate]);

  const hsContactId = searchParams.get('hsContactId') ?? undefined;

  // Track signup page arrival with hsContactId parameter
  useEffect(() => {
    if (hsContactId && !pauseLoadingForSsoCheck) {
      captureAnalyticsEvent(AnalyticsEvent.SIGNUP_PAGE_ARRIVED, {
        hubSpotContactId: hsContactId || undefined,
        userAgent: navigator.userAgent,
        referrer: document.referrer,
      });
    }
  }, [hsContactId, pauseLoadingForSsoCheck]);

  const handleRegisterSuccess = (value: boolean) => {
    setIsRegisterSuccess(value);
  };

  return pauseLoadingForSsoCheck ? (
    <div />
  ) : (
    <div className='min-h-screen bg-[#E5E5E5]'>
      <div className='flex flex-col items-center'>
        <div className='pt-10 pb-10'>
          <img
            src={theme.networkLogo}
            alt={t('icon_alt_brand_logo', { brandName: getbrandname() })}
            style={{ width: 'auto', height: '54px' }}
          />
        </div>
        <div className='w-[440px] bg-white rounded py-[48px] px-[40px] border-grey0 items-center'>
          <StepWizard
            transitions={{
              enterRight: '',
              enterLeft: '',
              exitRight: '',
              exitLeft: '',
              intro: '',
            }}
          >
            <RegisterCreateAccount
              registerSuccess={handleRegisterSuccess}
              hsContactId={hsContactId}
            />
          </StepWizard>
        </div>
        {!isRegisterSuccess && (
          <div
            className='w-[440px] px-4 py-2 text-grey5 font-normal'
            style={{ fontSize: '12px', lineHeight: '20px' }}
          >
            <Trans i18nKey='terms_of_service_register_msg_3' values={{ whiteLabelCompanyName }} />
          </div>
        )}
      </div>
    </div>
  );
};
